import { BaseField } from './BaseField';

const imgFloorIcon = "/assets/floor-icon.svg";

export class FloorField extends BaseField {
  constructor() {
    super({
      key: 'floor',
      icon: imgFloorIcon,
      defaultLabel: 'Piętro'
    });
  }

  renderForList(property) {
    return {
      label: this.defaultLabel,
      value: property.location.floor_label
    };
  }

  renderForCard(property) {
    return this.renderForList(property);
  }
}
